import React from 'react'
import SubHeader from '../components/SubHeader'
import GetInTouch from '../components/GetInTouch'
const Contact = () => {
  return (
    <>
      <SubHeader />
      <GetInTouch />
    </>
  )
}

export default Contact
